import React, { useEffect } from "react";
import { LoggedInView } from "../common/LoggedInView";
import { Link, useParams } from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import { getVendorContacts } from "../../store/reducers/VendorContactsSlice";
import {VendorContactsTable} from "./components/VendorContactsTable";
import {getCurrentVendor} from "../../store/reducers/VendorsSlice";

interface VendorContactsScreenProps {}

export const VendorContactsScreen: React.FC<VendorContactsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const { vendorId } = useParams<{ vendorId: string }>();

    const vendorsState = useAppSelector((state) => state.vendors);

    useEffect(() => {
        if (vendorId) {
            dispatch(getCurrentVendor({ id: vendorId }));
            dispatch(getVendorContacts({ vendorId: parseInt(vendorId, 10) })); 
        }
    }, [vendorId]);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Hankija {vendorsState?.currentVendor?.name} kontaktisikud</h1>
            <VendorContactsTable vendorId={String(vendorId)} />
            <ul className="table-actions">
                <li><Link to={`/vendors/${vendorId}/contacts/new`}><strong>Lisa
                    kontakt</strong></Link></li>
            </ul>
        </LoggedInView>
    );
};